module.exports = __webpack_public_path__ + "static/media/ic_code.5176ca80.svg";